<template>
  <div class="frame-outer">
    <!-- <iframe class="chart-full" style="border: none" ref="frameRef"></iframe> -->
  </div>
</template>

<script>
export default {
  name: 'FrameOuter',
  components: {},
  mounted() {},
};
</script>

<style scoped>
.chart-full {
  width: 100%;
  height: 100%;
}
</style>
